// extracted by mini-css-extract-plugin
export var active = "navHeader-module--active---jPyQ";
export var headerContainer = "navHeader-module--headerContainer--Sf782";
export var home = "navHeader-module--home--8vIQw";
export var homeHeader = "navHeader-module--homeHeader--NM4kE";
export var logoElement = "navHeader-module--logoElement--40SQZ";
export var mobileNav = "navHeader-module--mobileNav---4vAH";
export var mobileNavButtonId = "navHeader-module--mobileNavButtonId--NbvLH";
export var mobileNavButtonTitle = "navHeader-module--mobileNavButtonTitle--9rWBg";
export var mobileNavButtonTitleId = "navHeader-module--mobileNavButtonTitleId--p1PoQ";
export var mobileNavContainer = "navHeader-module--mobileNavContainer--NekYq";
export var ttNav = "navHeader-module--ttNav--L0ZFN";
export var ttNavContent = "navHeader-module--ttNavContent--Cjvpv";